import React, { useEffect, useState,useRef } from "react";
import { connect } from "react-redux";
import {Link} from 'react-router-dom';
import _ from "lodash";
import Modal from "react-bootstrap/Modal";
import Logo from "../../assets/normLogo.png";
import Form from "react-bootstrap/Form";
import CloseButton from "react-bootstrap/esm/CloseButton";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Swal from "sweetalert2";
import Pagination from "react-js-pagination";
import Loader from '../../elements/Loader';

import {AuctionUpdate,hideAuctionModal,showAuctionModal,showEditAuctionModal,hideEditAuctionModal,getAuctions,AuctionEdit,inputHandler,registerAuction, AuctionDelete } from "../../../redux/actions";

function Auctions(props) {


// const [addAuctionData,setAddAuctionData] = useState({name:''});
const [AuctionData,setAuctionData] = useState({name:'',onId:''});
const [checkedState, setCheckedState] = useState([]);
const checkBoxRef = useRef([]);


  useEffect(() => {
    props.getAuctions(props.currentPage);
  }, [props.registerAuctionSuccess,props.updateSuccess,props.deleteSuccess]);


useEffect(()=>{
setAuctionData({...AuctionData,'name':props.editDetails?.data?.auction_name||''})
},[props.editDetails])



  //   useEffect(()=>{

  //     setRoleNameEdit({name:props.showPermissions?.role.name?props.showPermissions?.role.name:''});
    
     
  
  
  // },[props.showPermissions] )



  const onInputchange = (e) => {
    props.inputHandler({ key: e.target.name, value: e.target.value });
    // setRoleData({ ...roleData, [e.target.name]: e.target.value });
  };





  const onInputUpdatechange = (e) => {
    // props.inputHandler({ key: e.target.name, value: e.target.value });
    setAuctionData({...AuctionData, name:e.target.value  });
  };

// ============================================
//  to rigister role modal
// ============================================
  const handleClose = () => {
  
    props.hideAuctionModal()

  };
  const handleShow = () => {

    props.showAuctionModal()
  
  };

// ============================================
// to register edit modal open and close
// ============================================

  const handleEditClose = () => {
    props.hideEditAuctionModal();

  };

  const handleEditShow=()=>{
    props.showEditAuctionModal()

  }




const deleteAuction = (id) => {
  Swal.fire({
    title: "Are you sure?",
    text: "You want to delete this Auction",
    icon: "warning",
    width: 400,
    showCancelButton: true,
    timer: 4000,
    timerProgressBar: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!",
  }).then((result) => {
    if (result.isConfirmed) {
      props.AuctionDelete(id, props.currentPage);
    }
  });
};





const submitAuction = (e) => {
  e.preventDefault();
  let name=props?.name;
  if(name){
    props.registerAuction(name)
  }
}


const UpdateAuction = (e) => {
  e.preventDefault();
  let name=AuctionData.name;
  let id=AuctionData.onId;
  let currentPage=props.AuctionsList?.data?.current_page;
  props.AuctionUpdate(id,name,currentPage);
  
}




  return (
    <>
      

      <div className="container-Layer">
      <Link to="/home/settings" className="back-button-outer">

    <center> <i className="fa fa-arrow-left" style={{color:'white'}}></i> </center> 
      </Link>

      <div className="row">
      <div className="col-md-7">   
      <div className="addButton"><a onClick={handleShow} className="btn btn-primary">Add Auction</a></div>
      </div>
      <div className="col-md-5">

      </div>

     
        </div>

        <div className="row text-center pt-4">
          {props.loading ? 
            <Loader
              width={"40px"}
              height={"40px"}
              iconColor={"white"}
              backgroundColor={"#deb726"}
              left={"0%"}
              top={"30%"}
            />
          :
            props.AuctionsList?.data?.data.map((list, index) => {
              return (
                <div
                  className="col-xl-3 col-sm-4 col-md-3 mb-5 card-outer"
                  key={index}
                >
                
            <div
              className="shadow-sm py-2 px-4 settings-list-card "
              style={{ borderLeft: "5px solid #fcba03" }}
            >
              <p className="mt-2 text-uppercase">{list.auction_name}</p>
              {/* <span className="small text-uppercase text-muted">Admin</span> */}
              <ul className="social mb-0 list-inline mt-3">
                
                <li className="list-inline-item settings-links">
                  <a  onClick={
                    ()=>{
                      setAuctionData({...AuctionData,'onId':list.id})
                      props.AuctionEdit(list.id)
                               setTimeout(()=>{
                                handleEditShow()
                               },190)    

                    }} className="icons-link">
                    <i className="fa fa-edit edit"></i>
                  </a>
                </li>
                <li className="list-inline-item settings-links">
                  <a  onClick={()=>deleteAuction(list.id)} className="icons-link">
                    <i className="fa fa-trash trash"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
              );
            })}

          
            {props.AuctionsList && (
        <div className="row">
          <div className="paginate col-md-6">
            <Pagination
              activePage={props.AuctionsList?.data?.current_page}
              itemsCountPerPage={props.AuctionsList?.data?.per_page}
              totalItemsCount={props.AuctionsList?.data.total}
              //   pageRangeDisplayed={5}
              onChange={(pageNumber) => props.getAuctions(pageNumber)}
              itemClass="page-item"
              linkClass="page-link"
              lastPageText="Last"
              firstPageText="First"
            />
          </div>
        </div>
      )}



        </div>
      </div>


{/* ======================
Add Role Modal
====================== */}
      <Modal show={props.showWarModal} onHide={handleClose} size="md" >
        <Modal.Header className="modal-header-color">
          <img
            src={Logo}
            style={{ width: "70px", height: "35px", paddingRight: "10px" }}
          />
          <Modal.Title className="modal-header-text">Add New Auction </Modal.Title>
          <CloseButton variant={"white"} onClick={handleClose}></CloseButton>
        </Modal.Header> 

        <form onSubmit={submitAuction}>
          <Modal.Body >
            <div className="row">
              <div className="col-md-12 mb-3">
                <FloatingLabel label="Auction Name">
                  <Form.Control
                    type="input"
                    placeholder=" "
                    name="name"
                    value={props?.name}
                    required
                    onChange={(e) => onInputchange(e)}
                    isInvalid={props.AuctionRegisterErrors?.error?.Auction_name?true:false}
                  />

                </FloatingLabel>

                {props.AuctionRegisterErrors?.error?.Auction_name ? (
                  <div className="validation-error">
                    The Auction name already exists !
                  </div>
                ) : (
                  ""
                )}

              </div>
            </div>
   
            {/* <Button text={"Submit"} class={"btn btn-primary"} type={'submit'} /> */}
          </Modal.Body>

          <Modal.Footer className="modal-footer">
            <button className="btn-submit" type="submit">
              Add
            </button>
          </Modal.Footer>
        </form>
      </Modal>











{/* ======================
Edit Role Modal
====================== */}
<Modal show={props.showEditWarModal} onHide={handleEditClose} size="md" >
        <Modal.Header className="modal-header-color">
          <img
            src={Logo}
            style={{ width: "70px", height: "35px", paddingRight: "10px" }}
          />
          <Modal.Title className="modal-header-text">Edit Auction </Modal.Title>
          <CloseButton variant={"white"} onClick={handleEditClose}></CloseButton>
        </Modal.Header> 

        <form onSubmit={UpdateAuction}>
          <Modal.Body >
            <div className="row">
              <div className="col-md-12 mb-3">
                <FloatingLabel label="Auction Name">
                  <Form.Control
                    type="input"
                    placeholder=" "
                    name="editAuctionName"
                    value={AuctionData.name||''}
                    required
                    onChange={(e) => onInputUpdatechange(e)}
                    isInvalid={props.AuctionUpdateErrors?.error?.Auction_name ?true:false}
                  />

                </FloatingLabel>

                {props.AuctionUpdateErrors?.error?.Auction_name ? (
                  <div className="validation-error">
                    The auction name already exists, you can't update it with this Auction name !
                  </div>
                ) : (
                  ""
                )}

              </div>
            </div>
    
            {/* <Button text={"Submit"} class={"btn btn-primary"} type={'submit'} /> */}
          </Modal.Body>

          <Modal.Footer className="modal-footer">
            <button className="btn-submit" type="submit">
              Done
            </button>
          </Modal.Footer>
        </form>
      </Modal>








    </>
  );
}

const mapStateToProps = (state) => {
  const {loading,AuctionsList,showWarModal,showEditWarModal,name,registerAuctionSuccess,AuctionRegisterErrors,currentPage,editDetails,updateSuccess,deleteSuccess,AuctionUpdateErrors} = state.SettingsAuctionHandler;

  return {
    loading: loading,
    name:name,
    AuctionRegisterErrors:AuctionRegisterErrors,
    currentPage:currentPage,
    AuctionsList:AuctionsList,
    showWarModal:showWarModal,
    showEditWarModal:showEditWarModal,
    registerAuctionSuccess:registerAuctionSuccess,
    editDetails:editDetails,
    updateSuccess:updateSuccess,
    deleteSuccess:deleteSuccess,
    AuctionUpdateErrors:AuctionUpdateErrors,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {


     inputHandler: ({ key, value }) => dispatch(inputHandler({ key, value })),
      getAuctions:(currentPage)=>dispatch(getAuctions(currentPage)),
      showAuctionModal:()=>dispatch(showAuctionModal()),
      hideAuctionModal:()=>dispatch(hideAuctionModal()),
      showEditAuctionModal:()=>dispatch(showEditAuctionModal()),
      hideEditAuctionModal:()=>dispatch(hideEditAuctionModal()),
      registerAuction:(name)=>dispatch(registerAuction(name)),
      AuctionEdit:(id)=>dispatch(AuctionEdit(id)),
      AuctionUpdate:(id,name,currentPage)=>dispatch(AuctionUpdate(id,name,currentPage)),
      AuctionDelete:(id,currentPage)=>dispatch(AuctionDelete(id,currentPage)),
  };


};

export default connect(mapStateToProps, mapDispatchToProps)(Auctions);



// =============================
// design version: 1.0
// design by sabaoon bedar
// =============================